var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.responses,"items-per-page":100},scopedSlots:_vm._u([{key:"item.Link",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"medium":"","color":"primary","href":item.Link.replace('https://wb-bi-ppp-practice.firebaseapp.com/','/'),"target":"_blank"}},[_vm._v("View")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }